module.exports = __webpack_public_path__ + "static/media/starbucks_icon.d08e3832.png";